import axios from "axios";
export default {
    deleteProject: (projectId) => axios.post("/Projects/DeleteProject", { Id: projectId })
};
